// removed by extract-text-webpack-plugin
module.exports = {"container":"GeneralError__container___1wjz2","content":"GeneralError__content___97PxC","text":"GeneralError__text___Z1XR7","header":"GeneralError__header___s60dd","subtitle":"GeneralError__subtitle___vCA6D","contactBlock":"GeneralError__contactBlock___3CLth","buttons":"GeneralError__buttons___yMLKE","buttonContainer":"GeneralError__buttonContainer___2OGs9"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/GeneralError.css
// module id = 1557
// module chunks = 0